export const includesWithNarrowing = <TItem>(
  array: Array<TItem>,
  // This any is the whole point.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchElement: any,
  fromIndex?: number
): searchElement is TItem => array.includes(searchElement, fromIndex);
